import { useState } from "react"
import { PropTypes } from "prop-types"
import classNames from "classnames"

import Label from "../Label"
import Input from "../Input"
import errorPropTypes from "../errorPropTypes"

export function CheckBox(props) {
  const { checked, disabled, id, label, error, onChange, ...otherProps } = props
  const [newChecked, setChecked] = useState(checked)

  const handleChange = e => {
    setChecked(!newChecked)
    onChange(e)
    e.target.id &&
      setTimeout(() => {
        document.getElementById(e.target.id).focus()
      }, 100)
  }

  return (
    <div
      className={classNames("oj-check-box", {
        checked: newChecked,
        "state-disabled": disabled
      })}
    >
      <Input
        type="checkbox"
        id={id}
        hasError={error?.hasError}
        disabled={disabled}
        checked={newChecked}
        onChange={handleChange}
        {...otherProps}
      />
      <Label inputId={id}>{label}</Label>
    </div>
  )
}

CheckBox.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.shape(errorPropTypes),
  label: PropTypes.node.isRequired,
  onChange: PropTypes.func
}

export default CheckBox
